import { createSender, r } from '@/plugins/resource'
import { prefixAPI, queryPostfix } from '@/plugins/resource/api'

const MODEL = 'branch-moderation'
const ACTION_MODEL = MODEL + '/action'

export const BRANCH_MODERATION_REASONS_LIST_URL = prefixAPI(MODEL + '/reason/list/')

export const branchModerationApi = {
  action: {
    confirm: r('/confirm/', ACTION_MODEL, createSender),
    reject: r('/reject/', ACTION_MODEL, createSender),
    takenForModeration: r('/taken-for-moderation/', ACTION_MODEL, createSender),
  },
  history: r(queryPostfix('/history/list/{id}/', ['filters']), MODEL),
  list: r(queryPostfix('/list/', ['filters']), MODEL),
  filterList: r('/filter-list/', MODEL),
  detail: r('/detail{/id}/', MODEL),
  reasonList: r('/reason/list/', MODEL),
}
